/**
 * BundleContentsToggle.js — collapsible included-items list for bundle cart lines
 */

import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { fmt } from '../i18n/format';
import './BundleContentsToggle.css';

const BundleContentsToggle = ({ bundleProducts = [], listIdPrefix = 'bundle' }) => {
  const [expanded, setExpanded] = useState(false);
  const { t } = useLanguage();
  const b = t.shop.bundle;

  if (!bundleProducts.length) {
    return null;
  }

  const listId = `${listIdPrefix}-contents`;
  const n = bundleProducts.length;
  const toggleLabel = expanded
    ? fmt(n === 1 ? b.hideItemsOne : b.hideItemsMany, { n })
    : fmt(n === 1 ? b.showItemsOne : b.showItemsMany, { n });

  return (
    <div className="bundle-contents">
      <button
        type="button"
        className="bundle-contents-toggle"
        onClick={() => setExpanded((open) => !open)}
        aria-expanded={expanded}
        aria-controls={listId}
      >
        {toggleLabel}
        <span className="bundle-contents-chevron" aria-hidden="true">
          {expanded ? '▲' : '▼'}
        </span>
      </button>
      {expanded && (
        <div id={listId} className="bundle-contents-panel">
          <ul className="bundle-contents-list">
            {bundleProducts.map((bp, idx) => (
              <li key={bp.id || idx}>
                <span className="bundle-contents-item-name">{bp.name}</span>
                {(bp.selectedSize || bp.selectedColor) && (
                  <span className="bundle-contents-item-meta">
                    {bp.selectedSize && fmt(b.size, { value: bp.selectedSize })}
                    {bp.selectedSize && bp.selectedColor && ', '}
                    {bp.selectedColor && fmt(b.color, { value: bp.selectedColor })}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default BundleContentsToggle;
